// utils
import axios from '../utils/axios';
import { SetCookieType } from './types';

// ----------------------------------------------------------------------

export const setSession = (token: string | null) => {
  if (token) {
    localStorage.setItem('token', token);
    const tokenData = parseJwt(token);
    // const serverToken = window.btoa(`${tokenData.username}:${tokenData.password}`);

    axios.defaults.headers.common['ar-access-token'] = token;
  } else {
    localStorage.removeItem('accessToken');

    delete axios.defaults.headers.common['ar-access-token'];
  }
};

export const setCookie = (props: SetCookieType) => {
  const { name, value, days } = props;
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

export const parseJwt = (token: string) => {
  try {
    // return JSON.parse(atob(token.split('.')[1]));
    return JSON.parse(decodeURIComponent(window.atob(token.split('.')[1])));
  } catch (e) {
    return null;
  }
};
